import { styled } from "@material-ui/core/styles"

export const Background = styled('div')(({ theme }) => ({
    backgroundColor: theme.colors.grey01,
}));

export const Container = styled('div')({
    margin: '0 auto',
    width: '90vw',
    maxWidth: '1170px',
    padding: '1rem 0px',
});

export const Main = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
});